import Notifications from './Notifications';
import { connect } from 'react-redux';
import { userDataSel } from 'src/store/modules/user';
import { withI18n } from 'react-i18next';
import {
  isLoggedInSel
} from 'src/store/modules/signin';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state),
    isLoggedIn: isLoggedInSel(state)
  };
};

export const pureComponent = Notifications;
export default connect(mapStateToProps, null)(withI18n()(Notifications));
